import type { AnswerStatus } from "@/models/enum/answerStatus";

export class QuestionnaireSideMenuItem {
  sectionTitle: string;
  isSectionCompleted: AnswerStatus;

  constructor(sectionTitle: string, isSectionCompleted: AnswerStatus) {
    this.sectionTitle = sectionTitle;
    this.isSectionCompleted = isSectionCompleted;
  }
}
